import type { Config } from 'tailwindcss';

export default {
    darkMode: ['class'],
    content: [
    './src/pages/**/*.{js,ts,jsx,tsx,mdx}',
    './src/components/**/*.{js,ts,jsx,tsx,mdx}',
    './src/app/**/*.{js,ts,jsx,tsx,mdx}',
    './src/stories/*.{js,ts,jsx,tsx,mdx}',
  ],
  future: {
    hoverOnlyWhenSupported: true,
  },
  theme: {
  	screens: {
  		sm: '40rem',
  		md: '48rem',
  		lg: '64rem',
  		xl: '80rem',
  		'2xl': '96rem',
  		'3xl': '110rem'
  	},
  	extend: {
  		typography: {
  			DEFAULT: {
  				css: {
  					color: 'inherit',
  					'*': {
  						color: 'inherit'
  					}
  				}
  			}
  		},
  		keyframes: {
  			'fade-pulse': {
  				'0%, 100%': {
  					opacity: '1'
  				},
  				'50%': {
  					opacity: '0.4'
  				}
  			},
				spinner: {
					to: {
						transform: 'rotate(360deg)'
					}
				}
  		},
  		animation: {
  			'fade-pulse': 'fade-pulse 1s ease-in-out infinite',
				spinner: 'spinner 1s ease-in-out infinite'
  		},
  		gap: {
  			'120': '7.5rem',
  			'4.5': '1.125rem',
  			'36.75': '9.88rem'
  		},
  		colors: {
  			transparent: 'transparent',
  			current: 'currentColor',
  			background: 'hsl(var(--background))',
  			foreground: 'hsl(var(--foreground))',
  			card: {
  				DEFAULT: 'hsl(var(--card))',
  				foreground: 'hsl(var(--card-foreground))'
  			},
  			popover: {
  				DEFAULT: 'hsl(var(--popover))',
  				foreground: 'hsl(var(--popover-foreground))'
  			},
  			primary: {
  				DEFAULT: 'hsl(var(--primary))',
  				foreground: 'hsl(var(--primary-foreground))'
  			},
  			secondary: {
  				DEFAULT: 'hsl(var(--secondary))',
  				foreground: 'hsl(var(--secondary-foreground))'
  			},
  			muted: {
  				DEFAULT: 'hsl(var(--muted))',
  				foreground: 'hsl(var(--muted-foreground))'
  			},
  			accent: {
  				DEFAULT: 'hsl(var(--accent))',
  				foreground: 'hsl(var(--accent-foreground))'
  			},
  			destructive: {
  				DEFAULT: 'hsl(var(--destructive))',
  				foreground: 'hsl(var(--destructive-foreground))'
  			},
  			border: 'hsl(var(--border))',
  			input: 'hsl(var(--input))',
  			ring: 'hsl(var(--ring))',
  			chart: {
  				'1': 'hsl(var(--chart-1))',
  				'2': 'hsl(var(--chart-2))',
  				'3': 'hsl(var(--chart-3))',
  				'4': 'hsl(var(--chart-4))',
  				'5': 'hsl(var(--chart-5))'
  			}
  		},
  		outlineWidth: {
  			'2': '0.125rem',
  			'3': '0.188rem'
  		},
  		borderWidth: {
  			'2': '0.125rem',
  			'3': '0.188rem'
  		},
  		height: {
  			'35': '2rem',
  			'92': '5.75rem',
  			'120': '7.5rem',
  			'134': '8.375rem',
  			'160': '10rem',
  			'165': '13.5rem',
  			'230': '19.29644rem',
  			'313': '19.56rem',
  			'343': '21.438rem',
  			'390': '24.375rem',
  			'420': '26.225rem',
  			'500': '38.27319rem',
  			'650': '40.625rem',
  			'714': '44.625rem',
  			'773': '48.375rem',
  			'800': '50.0625rem',
  			'0.01': '0.063rem',
  			'0.03': '0.188rem',
  			'4.5': '1.125rem'
  		},
  		minHeight: {
  			'45': '2.813rem',
  			'52': '3.25rem',
  			'62': '3.875rem',
  			'92': '5.75rem',
  			'106': '6.625rem',
  			'110': '6.875rem',
  			'134': '8.375rem',
  			'140': '8.75rem',
  			'150': '10.62rem',
  			'176': '11rem',
  			'350': '20.1875rem',
  			'374': '23.375rem',
  			'500': '31.25rem',
  			'515': '31.5625rem',
  			'773': '48.375rem',
  			'775': '48.438rem'
  		},
  		maxHeight: {
  			'15': '3.75rem',
  			'178': '11.125rem',
  			'230': '14.375rem',
  			'250': '15.625rem',
  			'270': '17rem',
  			'614': '38.375rem',
  			'618': '38.625rem',
  			'680': '42.5rem',
  			'711': '44.4375rem',
  			'765': '47.8125rem',
  			'773': '48.375rem',
  			'775': '48.438rem',
  			'822': '51.375rem'
  		},
  		width: {
  			'35': '2rem',
  			'63': '3.938rem',
  			'92': '5.75rem',
  			'106': '6.625rem',
  			'134': '8.375rem',
  			'142': '8.875rem',
  			'170': '11.25rem',
  			'176': '11rem',
  			'258': '16.125rem',
  			'280': '17.5rem',
  			'380': '23.75rem',
  			'598': '37.375rem',
  			'620': '41.25rem',
  			'0.01': '0.063rem',
  			'0.03': '0.188rem',
  			'4.5': '1.125rem'
  		},
  		maxWidth: {
  			'180': '11.25rem',
  			'370': '23.125rem',
  			'570': '35.625rem',
  			'598': '37.375rem',
  			'760': '47.5rem',
  			'775': '48.438rem',
  			'790': '54.625rem',
  			'1042': '65.125rem',
  			'1172': '73.25rem',
  			'1760': '110rem'
  		},
  		minWidth: {
  			'169': '10.563rem',
  			'300': '18.75rem',
  			'320': '20rem'
  		},
  		fontFamily: {
  			Figtree: [
  				'figtree',
  				'serif'
  			],
  			Thermal: [
  				'thermal-variable',
  				'sans-serif'
  			]
  		},
  		margin: {
  			'7': '1.75rem',
  			'15': '3.75rem',
  			'17': '1.063rem',
  			'18': '1.125rem',
  			'19': '4.5rem',
  			'22': '5.5rem',
  			'25': '6.5rem',
  			'48': '3rem',
  			'60': '3.75rem',
  			'90': '5.625rem',
  			'95': '5.938rem',
  			'120': '7.5rem',
  			'180': '11.25rem',
  			'200': '12.5rem',
  			'0.6': '0.313rem',
  			'0.7': '0.4375rem',
  			'0.85': '0.62rem',
  			'0.13': '0.88rem',
  			'4.5': '1.125rem',
  			'5.2': '1.38rem',
  			'5.3': '1.625rem',
  			'10.75': '2.688rem',
  			'13.5': '3.25rem',
  			'6.5': '1.625rem',
  			'9.5': '2.375rem'
  		},
  		aspectRatio: {
  			logo_d: '258 / 85',
  			logo_m: '142 / 47'
  		},
  		fill: {
  			chiclet: {
  				location: {
  					default: 'var(--color-ui-chiclet-location-icon)',
  					hover: 'var(--color-ui-chiclet-location-icon-hover)'
  				}
  			}
  		},
  		padding: {
  			'13': '3.125rem',
  			'15': '3.75rem',
  			'22': '5.5rem',
  			'23': '5.75rem',
  			'25': '6.5rem',
  			'27': '1.688rem',
  			'29': '7.25rem',
  			'62': '4.56rem',
  			'72': '4.5rem',
  			'120': '7.5rem',
  			'140': '8.75rem',
  			'157': '9.813rem',
  			'180': '11.25rem',
  			'1.75': '0.438rem',
  			'3.25': '0.875rem',
  			'3.75': '0.938rem',
  			'4.5': '1.063rem',
  			'4.75': '1.125rem',
  			'5.5': '1.375rem',
  			'6.5': '1.625rem',
  			'7.5': '1.875rem',
  			'8.5': '2.0625rem',
  			'8.9': '2.438rem',
  			'10.5': '2.625rem',
  			'11.5': '2.875rem',
  			'13.5': '3.25rem',
  			'14.5': '3.5rem'
  		},
  		zIndex: {
  			'100': '100'
  		},
  		top: {
  			'30': '1.875rem'
  		},
  		borderRadius: {
  			'15': '0.938rem',
  			'18': '1.125rem',
  			'30': '1.875rem',
  			'40': '2.5rem',
  			'80': '5rem',
  			lg: 'var(--radius)',
  			md: 'calc(var(--radius) - 2px)',
  			sm: 'calc(var(--radius) - 4px)'
  		},
  		lineHeight: {
  			'74': '0.74',
  			'83': '0.83',
  			'95': '0.95',
  			'135': '1.35'
  		},
  		letterSpacing: {
  			'0.64': '0.04rem'
  		},
  		fontSize: {
  			'10': '0.625rem',
  			'11': '0.688rem',
  			'13': '0.813rem',
  			'15': '0.938rem',
  			'18': '1.125rem',
  			'20': '1.25rem',
  			'22': '1.375rem',
  			'24': '1.5rem',
  			'26': '1.625rem',
  			'28': '1.75rem',
  			'32': '2rem',
  			'38': '2.375rem',
  			'40': '2.5rem',
  			'42': '2.625rem',
  			'44': '2.75rem',
  			'52': '3.25rem',
  			'58': '3.625rem',
  			'62': '3.875rem',
  			'82': '5.125rem',
  			'106': '6.625rem',
  			'176': '11rem'
  		},
  		textColor: {
  			skin: {
  				primary: 'var(--color-text-primary)',
  				'primary-inverted': 'var(--color-surface-primary)',
  				secondary: 'var(--color-text-secondary)',
  				tertiary: 'var(--color-text-tertiary)',
  				'headline-primary': 'var(--color-headline-primary)',
  				'subhead-primary': 'var(--color-text-subheader)',
  				'cta-primary': 'var(--color-cta-text-primary)',
  				'cta-default': 'var(--color-cta-default)',
  				'cta-hover': 'var(--color-cta-hover)',
  				'cta-press': 'var(--color-cta-press)',
  				'cta-subdued-default': 'var(--color-cta-subdued-default)',
  				'cta-subdued-hover': 'var(--color-cta-subdued-hover)',
  				'cta-subdued-press': 'var(--color-cta-subdued-press)',
  				brand: 'var(--color-text-brand)',
  				error: 'var(--color-ui-fill-alert)',
  				success: 'var(--color-success-primary)',
  				warning: 'var(--color-warning-primary)',
  				'decorative-primary': 'var(--color-decorative-primary)',
  				disabled: 'var(--color-field-text-disabled)',
  				alert: 'var(--color-ui-fill-alert)',
  				link: 'var(--color-text-hyperlink)',
  				media: 'var(--color-text-media)'
  			},
  			brand: 'var(--color-text-brand)',
  			chiclet: {
  				featured: 'var(--color-ui-chiclet-featured-text)',
  				default: 'var(--color-ui-chiclet-standard-text)',
  				offers: 'var(--color-ui-chiclet-offer-text)',
  				location: 'var(--color-ui-chiclet-location-text)',
  				'location-hover': 'var(--color-ui-chiclet-location-text-hover)'
  			},
  			cta: {
  				diminutive: 'var(--color-button-text-diminutive)',
  				fill: {
  					primary: 'var(--color-button-text-primary)',
  					secondary: 'var(--color-button-text-secondary)',
  					tertiary: 'var(--color-button-text-tertiary)'
  				},
  				outline: {
  					primary: 'var(--color-button-outline-text-primary)',
  					secondary: 'var(--color-button-outline-text-secondary)',
  					tertiary: 'var(--color-button-outline-text-tertiary)'
  				}
  			},
  			navLink: {
  				hover: 'var(--color-text-secondary)',
  				selected: 'var(--color-ui-knockout-primary)'
  			},
  			page: {
  				link: 'var(--color-page-link-text)',
  				linkHover: 'var(--color-page-link-hover)'
  			}
  		},
  		backgroundImage: {
  			'video-overlay': 'linear-gradient(to left, rgba(34, 33, 36, 0.65) 25%, rgba(34, 33, 36, 0.5) 50%)'
  		},
  		placeholderColor: {
  			search: 'var(--color-ui-fill-disabled)'
  		},
  		backgroundColor: {
  			skin: {
  				primary: 'var(--color-surface-primary)',
  				'primary-inverted': 'var(--color-text-primary)',
  				secondary: 'var(--color-surface-secondary)',
  				tertiary: 'var(--color-surface-tertiary)',
  				'cta-default': 'var(--color-cta-default)',
  				'cta-hover': 'var(--color-cta-hover)',
  				'cta-press': 'var(--color-cta-press)',
  				'cta-subdued-default': 'var(--color-cta-subdued-default)',
  				'cta-subdued-hover': 'var(--color-cta-subdued-hover)',
  				'cta-subdued-press': 'var(--color-cta-subdued-press)',
  				'ui-fill-primary': 'var(--color-ui-fill-primary)',
  				'stroke-primary': 'var(--color-ui-stroke-primary)',
  				'stroke-tertiary': 'var(--color-ui-stroke-tertiary)',
  				error: 'var(--color-ui-fill-alert)',
  				success: 'var(--color-success-primary)',
  				warning: 'var(--color-warning-primary)',
  				disabled: 'var(--color-neutral-400)',
  				brand: 'var(--color-ginko-200)',
  				globalBanner: 'var(--color-cream-100)',
  				filters: 'var(--color-neutral-100)'
  			},
  			progressBar: {
  				active: 'var(--color-blue-200)',
  				inactive: 'var(--color-neutral-500)'
  			},
  			chiclet: {
  				featured: 'var(--color-ui-chiclet-featured-fill)',
  				default: 'var(--color-ui-chiclet-standard-fill)',
  				offers: 'var(--color-ui-chiclet-offer-fill)',
  				location: 'var(--color-ui-chiclet-location-fill)',
  				'location-hover': 'var(--color-ui-chiclet-location-fill-hover)'
  			},
  			cta: {
  				primary: 'var(--color-button-fill-primary)',
  				secondary: 'var(--color-button-fill-secondary)',
  				tertiary: 'var(--color-button-fill-tertiary)',
  				diminutive: {
  					hover: 'var(--color-button-hover-diminutive)',
  					after: 'var(--color-button-text-diminutive)'
  				}
  			},
  			modal: {
  				overlay: 'var(--color-image-screen)'
  			},
  			isolatedIconHover: 'var(--color-neutral-100)',
  			ctaHover: {
  				primary: 'var(--color-button-hover-primary)',
  				secondary: 'var(--color-button-hover-secondary)',
  				tertiary: 'var(--color-button-hover-tertiary)'
  			},
  			navLink: {
  				hover: 'var(--color-surface-secondary)',
  				selected: 'var(--color-ui-fill-primary)'
  			}
  		},
  		outlineColor: {
  			cta: {
  				primary: 'var(--color-button-outline-primary)',
  				secondary: 'var(--color-button-outline-secondary)',
  				tertiary: 'var(--color-button-outline-tertiary)'
  			},
  			navLink: {
  				selected: 'var(--color-ui-knockout-primary)',
  				focus: 'var(--color-text-secondary)'
  			},
  			logo: 'var(--color-logo-fill)'
  		},
  		outlineOffset: {
  			'6': '0.375rem'
  		},
  		ringWidth: {
  			'2': '0.125rem'
  		},
  		ringColor: {
  			cta: {
  				fill: {
  					primary: 'var(--color-button-text-primary)',
  					secondary: 'var(--color-button-text-secondary)',
  					tertiary: 'var(--color-button-text-tertiary)'
  				},
  				outline: {
  					primary: 'var(--color-button-outline-primary)',
  					secondary: 'var(--color-button-outline-secondary)',
  					tertiary: 'var(--color-button-outline-tertiary)'
  				}
  			},
  			navLink: 'var(--color-ui-knockout-primary)',
  			checkbox: {
  				unchecked: 'var(--color-ui-stroke-secondary)',
  				checked: 'var(--color-ui-stroke-primary)'
  			},
  			dropdown: 'var(--color-ui-stroke-secondary)',
  			logo: 'var(--color-logo-fill)'
  		},
  		ringOffsetColor: {
  			cta: {
  				outline: 'var(--color-surface-primary)',
  				fill: {
  					primary: 'var(--color-button-hover-primary)',
  					secondary: 'var(--color-button-hover-secondary)',
  					tertiary: 'var(--color-button-hover-tertiary)'
  				}
  			},
  			navLink: 'var(--color-ui-fill-primary)'
  		},
  		boxShadow: {
  			card: '0 0 20px 5px rgba(43, 46, 39, 0.1) !important',
  			locationMenu: '0px 3px 5px rgba(43, 46, 39, 0.1)',
  		},
  		borderColor: {
  			skin: {
  				'stroke-primary': 'var(--color-ui-stroke-primary)',
  				'stroke-secondary': 'var(--color-ui-stroke-secondary)',
  				'stroke-tertiary': 'var(--color-ui-stroke-tertiary)',
  				'cta-default': 'var(--color-cta-default)',
  				'cta-hover': 'var(--color-cta-hover)',
  				'cta-press': 'var(--color-cta-press)',
  				'cta-text-primary': 'var(--color-cta-text-primary)',
  				'cta-subdued-default': 'var(--color-cta-subdued-default)',
  				'cta-subdued-hover': 'var(--color-cta-subdued-hover)',
  				'cta-subdued-press': 'var(--color-cta-subdued-press)',
  				'decorative-primary': 'var(--color-decorative-primary)',
  				error: 'var(--color-ui-fill-alert)',
  				success: 'var(--color-success-primary)',
  				warning: 'var(--color-warning-primary)'
  			},
  			nav: 'var(--color-ui-grid-secondary)',
  			accordion: 'var(--color-ginko-300)'
  		}
  	},
  },
  plugins: [require('@tailwindcss/typography'), require("tailwindcss-animate")],
} satisfies Config;
